export const palettes = [   
  {
    name: 'Mondrian',
    colors: ['#F7D744', '#D0341E', '#120D2D', '#425AC6', '#CAC9D1']
  },
  {
    name: 'Lissitzky',
    colors: ['#000000', '#ececec', '#ae0000', '#bfbcbc', '#aaaaaa']
  },
  {
    name: 'Gustafsson',
    colors: ['#16582E', '#e6982e', '#26386d', '#d62e2a', '#efe9d2']
  },
  {
    name: 'Pollock',
    colors: ['#662E9B', '#E57200', '#F7C59F', '#6B4226', '#E8DAB2']
  },
  {
    name: 'Martin',
    colors: ['#F2E3D5', '#E4C9C5', '#D9D1E0', '#BFD3DA', '#F7E5B9', '#D1D9C1', '#D6D2CD']
  },
  {
    name: 'LeWitt',
    colors: ['#433ca3', '#d84426', '#559f1a', '#f5de41', '#b21526', '#0c5ecb', '#579f18']
  }, 
  {
    name: 'Malevich',
    colors: ['#061965', '#3d7342', '#ac4415', '#d18c00', '#e0adbc', '#100e13', '#a63c1d']
  },
  {
    name: 'Riley',
    colors: ['#edb7b4', '#7db77b', '#465b95', '#d25366', '#2e2f31', '#dd7839', '#8d9acb', '#4d7b50']
  },
  {
    name: 'Stella',
    colors: ['#bac2e7', '#ef991b', '#406f86', '#824470', '#a8aa95', '#e34667', '#fad02f', '#4da146']
  }, 
];
  